module.exports = __webpack_public_path__ + "img/akamai.b8571391.png";